import React from "react";
import { Drawer, IconButton, Divider, Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import PlayerDetails from "../ui/PlayerDetails";
import EventCardView from "../cards/EventCardView";

const MobileMenu = ({
  open,
  onClose,
  players = [],
  currentTurn,
  name,
  playerCash = {},
  playerNetWorths = {},
  playerColors = {},
  playerEmojis = {},
  actionsRemaining = {},
  maxActionsPerTurn = 3,
  maxActionsThisTurn = {},
  currentPhase,
  myTurn,
  onEndTurn,
  onEndGame,
  onStartTutorial,
  onOpenRules,
  activeEvents = [],
  disconnectedPlayers = [],
  turnTimeRemaining = null,
  turnTimerPlayer = null,
  turnTimerTotal = 90,
  isHost = false,
  socket = null,
  room = null,
}) => {
  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      className="mobile-menu-drawer"
      PaperProps={{
        className: "mobile-menu-drawer-paper"
      }}
    >
      <div className="mobile-menu-header">
        <h2 className="mobile-menu-title">📱 Menu</h2>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </div>

      {/* Actions Section */}
      <div className="mobile-menu-section">
        <div className="mobile-menu-actions">
          <Button
            variant="outlined"
            onClick={() => {
              onOpenRules();
              onClose();
            }}
            fullWidth
            className="mobile-menu-button"
          >
            📖 Game Manual
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              onStartTutorial();
              onClose();
            }}
            fullWidth
            className="mobile-menu-button"
          >
            ℹ️ Tutorial
          </Button>
          {myTurn && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                onEndTurn();
                onClose();
              }}
              fullWidth
              className="mobile-menu-button-primary"
            >
              ✓ End Turn
            </Button>
          )}
          <Button
            variant="outlined"
            color="error"
            onClick={() => {
              if (window.confirm('Are you sure you want to end the game?')) {
                onEndGame();
                onClose();
              }
            }}
            fullWidth
            className="mobile-menu-button"
          >
            🚪 Leave Game
          </Button>
        </div>
      </div>

      <Divider />

      {/* Events Section */}
      {activeEvents && activeEvents.length > 0 && (
        <>
          <div className="mobile-menu-section">
            <h3 className="mobile-menu-section-title">Active Events</h3>
            <div className="mobile-menu-events">
              {activeEvents.map((event, index) => (
                <EventCardView
                    key={event.id || index}
                  event={event}
                  styleCardSize={{ width: "100%", maxWidth: "280px", height: "auto" }}
                  isNew={false}
                />
                          ))}
            </div>
          </div>
          <Divider />
        </>
      )}

      {/* Players Section */}
      <div className="mobile-menu-section">
        <h3 className="mobile-menu-section-title">Players</h3>
        <div className="mobile-menu-players">
          <PlayerDetails
            players={players}
            currentTurn={currentTurn}
            name={name}
            playerCash={playerCash}
            playerNetWorths={playerNetWorths}
            playerColors={playerColors}
            playerEmojis={playerEmojis}
            actionsRemaining={actionsRemaining}
            maxActionsPerTurn={maxActionsPerTurn}
            maxActionsThisTurn={maxActionsThisTurn}
            currentPhase={currentPhase}
            disconnectedPlayers={disconnectedPlayers}
            turnTimeRemaining={turnTimeRemaining}
            turnTimerPlayer={turnTimerPlayer}
            turnTimerTotal={turnTimerTotal}
            isHost={isHost}
            socket={socket}
            room={room}
            compact={true}
          />
        </div>
      </div>
    </Drawer>
  );
};

export default MobileMenu;

